import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Button } from '@src/components/Button';
import './styles.scss';

// 30 is for 3rem padding from .page class
const PAGE_PADDING = 30;

export default class Publish extends PureComponent {
  static propTypes = {
    children: PropTypes.node.isRequired,
  };

  state = {
    isBottom: false,
  };

  componentDidMount() {
    window.addEventListener('scroll', this.onScroll);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.onScroll);
  }

  onScroll = () => {
    const distanceFromBottom = document.body.scrollHeight - window.innerHeight - window.scrollY;
    const { isBottom } = this.state;

    if (!isBottom && distanceFromBottom <= PAGE_PADDING) {
      this.setState({ isBottom: true });
    } else if (isBottom && distanceFromBottom >= PAGE_PADDING) {
      this.setState({ isBottom: false });
    }
  };

  render() {
    const { children, ...restProps } = this.props;
    const { isBottom } = this.state;

    return (
      <div className={classnames('menu-publish', !isBottom && 'menu-publish--fixed')}>
        <Button className="menu-publish__button" {...restProps}>
          {children}
        </Button>
      </div>
    );
  }
}
